import { ChangeEventHandler } from 'react';

import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack, { StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Toggle from '@liquidweb-dev/undercurrent/Toggle';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import { useInput } from 'components/LWForm';

export interface VerificationMethodProps extends Omit<StackProps, 'children'> {
	auto?: boolean;
	dns?: boolean;
	metatag?: boolean;
	loading?: boolean;
}

const VerificationMethod = ({
	auto,
	dns,
	metatag,
	loading,
	sx,
	...rest
}: VerificationMethodProps) => {
	const { value, onValueChange } = useInput('verification_method');

	const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
		onValueChange(event.target.value);
	};

	return (
		<Stack sx={combineSx({ gap: 100 }, sx)} {...rest}>
			<Typography variant="body-sm" sx={{ fontWeight: 500 }}>
				Verification method
			</Typography>

			<Stack sx={{ flexDirection: 'row', gap: 100 }}>
				{loading ? (
					<Skeleton
						variant="rounded"
						sx={({ size }) => ({ width: '42px', height: size.sm })}
					/>
				) : (
					<>
						{auto && (
							<Toggle
								checked={value === 'auto'}
								type="radio"
								value="auto"
								onChange={handleChange}
							>
								Automatic
							</Toggle>
						)}
						{dns && (
							<Toggle
								checked={value === 'dns'}
								type="radio"
								value="dns"
								onChange={handleChange}
							>
								DNS records
							</Toggle>
						)}
						{metatag && (
							<Toggle
								checked={value === 'metatag'}
								type="radio"
								value="metatag"
								onChange={handleChange}
							>
								HTML meta tag
							</Toggle>
						)}
					</>
				)}
			</Stack>
		</Stack>
	);
};

export default VerificationMethod;
